<template>
    <div id="thank-you">
        <div class="row justify-content-center flex-column pt-4">
            <div class="col">
                <h2 class="home-title text-center">
                    Initial sign up complete <br />
                    We’ll reach out to you soon
                </h2>
                <div class="col">
                    <p class="noto-sans-font-title text-center m-auto d-block final-message">
                        Thank you for signing up to collaborate with WillYou.net We will go over your request and contact you with the next steps within the
                        next couple of days. Thanks for your patience.
                    </p>
                </div>
                <div class="col">
                    <ul class="list-inline list-unstyled footer-list">
                        <li class="list-inline-item footer-list-element">
                            <a href="#">
                                <img alt="facebook" src="../../../../assets/images/footer/facebook.svg" class="footer-social-icon" />
                            </a>
                        </li>
                        <li class="list-inline-item footer-list-element">
                            <a href="#">
                                <img alt="facebook" src="../../../../assets/images/footer/twitter.svg" class="footer-social-icon" />
                            </a>
                        </li>
                        <li class="list-inline-item footer-list-element">
                            <a href="#">
                                <img alt="facebook" src="../../../../assets/images/footer/instegram.svg" class="footer-social-icon" />
                            </a>
                        </li>
                        <li class="list-inline-item footer-list-element">
                            <a href="#">
                                <img alt="facebook" src="../../../../assets/images/footer/linkedin.svg" class="footer-social-icon" />
                            </a>
                        </li>
                        <li class="list-inline-item footer-list-element">
                            <a href="#">
                                <img alt="facebook" src="../../../../assets/images/footer/youtube.svg" class="footer-social-icon" />
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import ReCaptcha from "../../../components/ReCaptcha";

import axios from "axios";
import Loading from "../../../components/Loading.vue";
import PrettyCheck from "pretty-checkbox-vue/check";

export default {
    name: "join-now",
};
</script>

<style lang="scss" scoped>
.final-message {
    text-align: center;
    font-size: 14px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    font-family: "Noto Sans KR", sans-serif;
    color: #4a4a4a;
    max-width: 450px;
}
.footer-list {
    text-align: center;
}
</style>
